// @mui
import IconButton from "@mui/material/IconButton";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import { Link } from "react-router-dom";
import { API_URLS } from "src/api/apiUrls";
import useApiServices from "src/api/useApiServices";
// components
import Iconify from "src/components/iconify";
import Label from "src/components/label/label";
import { useBoolean } from "src/hooks/use-boolean";
import QRCodeDialog from "./QRCodeDialog";

// ----------------------------------------------------------------------

type Props = {
  row: any;
  refetch: any;
};

export default function AppsIntegrationsTableRow({ row, refetch }: Props) {
  const showQRCode = useBoolean();
  const { usePostApi, useDeleteApi } = useApiServices();

  const { mutate: restartSessionMutate } = usePostApi({
    url: `${API_URLS.RestartSession}`,
    onSuccess: () => {
      refetch();
    },
  });

  const { mutate: stopSessionMutate } = usePostApi({
    url: `${API_URLS.StopSession}`,
    onSuccess: () => {
      refetch();
    },
  });

  const { mutate: deleteSessionMutate } = useDeleteApi({
    url: `${API_URLS.DeleteSession}`,
    onSuccess: () => {
      refetch();
    },
  });

  return (
    <>
      <TableRow hover>
        <TableCell sx={{ whiteSpace: "nowrap", textAlign: "center" }}>
          {row?.name ?? "default"}
        </TableCell>
        <TableCell sx={{ whiteSpace: "nowrap", textAlign: "center" }}>
          <Label
            variant="soft"
            color={
              row?.status == "STARTING" || row?.status == "SCAN_QR_CODE"
                ? "success"
                : row?.status == "STOPPED"
                ? "warning"
                : "error"
            }
          >
            {row?.status ?? "Deleted"}
          </Label>
        </TableCell>
        <TableCell sx={{ whiteSpace: "nowrap", textAlign: "center" }}>
          <IconButton
            color="primary"
            sx={{
              gap: 1,
              borderRadius: 2,
              backgroundColor: "#FFF3E0",
            }}
            onClick={showQRCode.onTrue}
          >
            <Iconify icon="ic:baseline-qrcode" width={24} height={24} />
            <span style={{ fontWeight: 500, fontSize: "0.95rem" }}>
              Scan QR Code
            </span>
          </IconButton>
        </TableCell>
        <TableCell sx={{ whiteSpace: "nowrap", textAlign: "center" }}>
          <Tooltip title="ReStart" placement="bottom" arrow>
            <IconButton onClick={() => restartSessionMutate({})}>
              <Iconify
                icon="material-symbols:restart-alt-rounded"
                width="27"
                height="27"
                color="#FFAB8B"
              />
            </IconButton>
          </Tooltip>
          <Tooltip title="Stop" placement="bottom" arrow>
            <IconButton onClick={() => stopSessionMutate({})}>
              <Iconify
                icon="nimbus:stop"
                width="27"
                height="27"
                color="#FFAB8B"
              />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete" placement="bottom" arrow>
            <IconButton onClick={() => deleteSessionMutate(undefined)}>
              <Iconify
                icon="material-symbols:delete-outline"
                width="27"
                height="27"
                color="#FFAB8B"
              />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>

      <QRCodeDialog open={showQRCode.value} onClose={showQRCode.onFalse} />
    </>
  );
}
